var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bd-front-user"},[_c('InstitucionalHeader'),_c('div',{staticClass:"main-content"},[_c('router-view'),(_vm.$route.name !== 'Login')?_c('InstitucionalParceiros'):_vm._e()],1),_c('InstitucionalFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }